import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Zap, FileCheck, Infinity, ShieldCheck } from 'lucide-react';
import { trackAddToCart, trackInitiateCheckout } from '../utils/metaPixel';
function UrgencyCounter() {
  const [count, setCount] = useState(9);
  useEffect(() => {
    const decreaseCount = () => {
      setCount(prev => {
        if (prev <= 3) return prev;
        return prev - 1;
      });
      const nextInterval = Math.floor(Math.random() * (90000 - 45000 + 1)) + 45000;
      setTimeout(decreaseCount, nextInterval);
    };
    const timer = setTimeout(decreaseCount, Math.floor(Math.random() * 20000) + 10000);
    return () => clearTimeout(timer);
  }, []);
  return <div className="mt-4 flex flex-col items-center gap-1" data-id="element-223">
      <p className="text-red-500 font-bold text-lg animate-pulse" data-id="element-224">
        ⚠️ Últimos{' '}
        <motion.span key={count} initial={{
        scale: 1.4
      }} animate={{
        scale: 1
      }} className="inline-block text-2xl font-bebas" data-id="element-225">
          {count}
        </motion.span>{' '}
        mazos a este precio
      </p>
      <p className="text-white/50 text-sm" data-id="element-226">
        Después suben a{' '}
        <span className="text-white/70 font-semibold" data-id="element-227">$42.000 pesos</span>
      </p>
    </div>;
}
export function Pricing() {
  const [bumpSelected, setBumpSelected] = useState(false);
  const [bump2Selected, setBump2Selected] = useState(false);
  const displayPrice = bumpSelected && bump2Selected ? '$32.180' : bumpSelected || bump2Selected ? '$27.190' : '$22.200';
  const getCheckoutLink = () => {
    if (bumpSelected && bump2Selected) {
      return 'https://pay.hotmart.com/S105541783F?off=hrjni1z9&checkoutMode=10';
    }
    if (bumpSelected) {
      return 'https://pay.hotmart.com/S105541783F?off=9ye19nwc&checkoutMode=10&bid=1777567641787';
    }
    if (bump2Selected) {
      return 'https://pay.hotmart.com/S105541783F?off=sfbxlva5&checkoutMode=10';
    }
    return 'https://pay.hotmart.com/S105541783F?checkoutMode=10&_gl=1*1qohasg*_gcl_au*MzIzNDk2NTM5LjE3NzE4NTkzMjQ.*FPAU*MzIzNDk2NTM5LjE3NzE4NTkzMjQ.*_ga*MjA2NzE1OTc0MS4xNzYzODMxMDI4*_ga_GQH2V1F11Q*czE3NzcyODc2ODIkbzMwMiRnMSR0MTc3NzI4OTg1NiRqNTIkbDEkaDE2MTYyNjI0MDU.&bid=1777289868777';
  };
  const handleBump1Click = () => {
    setBumpSelected(!bumpSelected);
  };
  const handleBump2Click = () => {
    setBump2Selected(!bump2Selected);
  };
  return <section className="py-10 px-4 bg-navy-800 relative" data-id="element-228">
      <div className="max-w-3xl mx-auto text-center" data-id="element-229">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="bg-navy-900 rounded-3xl p-8 md:p-12 border border-white/10 shadow-2xl relative overflow-hidden" data-id="element-230">
          <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-gold to-transparent" data-id="element-231" />

          <p className="text-gold font-bebas text-2xl mb-2 tracking-widest" data-id="element-232">
            MAZO DE CARTAS ESPAÑOLAS +
          </p>
          <p className="text-gold font-bebas text-2xl mb-2 tracking-widest" data-id="element-233">
            MAZO DE "UNO" VERSIÓN SCALONETA
          </p>
          <p className="text-green-400 font-bebas text-xl mb-6 tracking-widest animate-pulse" data-id="element-234">
            + 2 BONOS GRATIS 🎁
          </p>

          <div className="mb-8 w-full max-w-md mx-auto" data-id="element-235">
            <img src="https://cdn.magicpatterns.com/uploads/owMBVXh4CqmVLkfH3FAS5w/37c67377-6743-4523-8444-a0a6cf017a62.png" alt="Pack completo Mazo de la Scaloneta con bonos" className="w-full h-auto rounded-xl shadow-[0_15px_40px_-10px_rgba(0,0,0,0.6),0_0_20px_rgba(212,175,55,0.1)]" data-id="element-236" />
          </div>

          <motion.div whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} className="inline-block mb-8" data-id="element-237">
            <a href={getCheckoutLink()} target="_blank" rel="noopener noreferrer" onClick={() => {
            trackAddToCart();
            trackInitiateCheckout();
          }} className="group relative inline-flex items-center justify-center gap-3 px-8 md:px-12 py-5 bg-gold text-navy-900 font-bold text-xl md:text-2xl rounded-xl overflow-hidden shadow-[0_0_40px_rgba(212,175,55,0.3)] hover:shadow-[0_0_60px_rgba(212,175,55,0.5)] transition-shadow animate-[pulse_2s_ease-in-out_infinite] no-underline" data-id="element-238">
              <div className="absolute inset-0 bg-white/20 translate-y-full group-hover:translate-y-0 transition-transform duration-300 ease-out" data-id="element-239" />
              <span className="relative z-10" data-id="element-240">QUIERO MI EDICIÓN LIMITADA</span>
            </a>
          </motion.div>

          {/* Order Bump 1 */}
          <div onClick={handleBump1Click} className={`max-w-md mx-auto mb-4 cursor-pointer rounded-xl border-2 p-4 text-left transition-all duration-300 ${bumpSelected ? 'border-green-400 bg-green-400/10 shadow-[0_0_20px_rgba(74,222,128,0.15)]' : 'border-gold/40 bg-navy-800/60 hover:border-gold/70'}`} data-id="element-241">
            <div className="flex items-start gap-3" data-id="element-242">
              <div className={`mt-0.5 flex-shrink-0 w-5 h-5 rounded border-2 flex items-center justify-center transition-colors ${bumpSelected ? 'bg-green-400 border-green-400' : 'border-white/40 bg-transparent'}`} data-id="element-243">
                {bumpSelected && <svg className="w-3 h-3 text-navy-900" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3} data-id="element-244">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" data-id="element-245" />
                  </svg>}
              </div>
              <div data-id="element-246">
                <p className="text-gold font-bold text-sm mb-1" data-id="element-247">
                  👉 SE VENDEN SOLOS 🔥
                </p>
                <p className="text-white text-sm leading-snug" data-id="element-248">
                  ¡SÍ! Quiero multiplicar mi ganancia sumando el{' '}
                  <span className="text-gold font-semibold" data-id="element-249">
                    Pack de 50 Stickers de la Selección
                  </span>{' '}
                  para el termo por solo{' '}
                  <span className="text-green-400 font-bold" data-id="element-250">$4.990</span>.
                </p>
                <p className="text-green-400 text-xs font-semibold mt-1.5" data-id="element-251">
                  💸 POTENCIAL DE RE-VENTA: Entre 9 y 10 lucas cada sticker!
                </p>
              </div>
            </div>
          </div>

          {/* Order Bump 2 */}
          <div onClick={handleBump2Click} className={`max-w-md mx-auto mb-8 cursor-pointer rounded-xl border-2 p-4 text-left transition-all duration-300 ${bump2Selected ? 'border-green-400 bg-green-400/10 shadow-[0_0_20px_rgba(74,222,128,0.15)]' : 'border-gold/40 bg-navy-800/60 hover:border-gold/70'}`} data-id="element-252">
            <div className="flex items-start gap-3" data-id="element-253">
              <div className={`mt-0.5 flex-shrink-0 w-5 h-5 rounded border-2 flex items-center justify-center transition-colors ${bump2Selected ? 'bg-green-400 border-green-400' : 'border-white/40 bg-transparent'}`} data-id="element-254">
                {bump2Selected && <svg className="w-3 h-3 text-navy-900" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3} data-id="element-255">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" data-id="element-256" />
                  </svg>}
              </div>
              <div data-id="element-257">
                <p className="text-gold font-bold text-sm mb-1" data-id="element-258">
                  👉 SÍ, QUIERO SUMAR EL IMÁN DE CLIENTES
                </p>
                <p className="text-white text-sm leading-snug" data-id="element-259">
                  Atraé a los clientes de la calle con carteles YA HECHOS,
                  listos para imprimir y colocar en la puerta de tu local por
                  solo <span className="text-green-400 font-bold" data-id="element-260">$4.990</span>.
                </p>
              </div>
            </div>
          </div>

          <div className="py-8 border-y border-white/5" data-id="element-261">
            <div className="flex items-center justify-center gap-3" data-id="element-262">
              <motion.span key={displayPrice} initial={{
              scale: 1.1,
              opacity: 0.7
            }} animate={{
              scale: 1,
              opacity: 1
            }} className="text-7xl md:text-8xl font-bebas text-white drop-shadow-lg" data-id="element-263">
                {displayPrice}
              </motion.span>
              <span className="text-2xl font-bebas text-gold mt-4" data-id="element-264">pesos</span>
            </div>
            <UrgencyCounter data-id="element-265" />

            <div className="flex items-center justify-center gap-2 mt-4 text-green-400 text-sm" data-id="element-266">
              <span data-id="element-267">🛡️</span>
              <span className="font-medium" data-id="element-268">
                Garantía de 7 días — Devolución 100%
              </span>
            </div>
          </div>

          {/* Payment methods */}
          <div className="mt-6 flex flex-col items-center gap-3" data-id="element-269">
            <div className="text-white/60 text-sm" data-id="element-270">Pagá con:</div>
            <div className="flex items-center justify-center gap-5" data-id="element-271">
              {/* VISA */}
              <div className="px-5 py-2.5 bg-[#142787] rounded-lg flex items-center justify-center" data-id="element-272">
                <span className="text-white font-bold italic text-lg tracking-wider" data-id="element-273">
                  VISA
                </span>
              </div>
              {/* Mastercard */}
              <div className="px-5 py-2.5 bg-navy-800 border border-white/10 rounded-lg flex items-center justify-center" data-id="element-274">
                <div className="w-6 h-6 rounded-full bg-[#EB001B] opacity-90 z-10 translate-x-1.5" data-id="element-275"></div>
                <div className="w-6 h-6 rounded-full bg-[#F79E1B] opacity-90 -translate-x-1.5" data-id="element-276"></div>
              </div>
              {/* Mercado Pago */}
              <div className="px-4 py-2 bg-white rounded-lg flex items-center justify-center gap-2" data-id="element-277">
                <img src="https://cdn.magicpatterns.com/uploads/iWmpLkgUmC8xuDezegJkdt/images.jpg" alt="Mercado Pago" className="h-8 w-8 object-contain" data-id="element-278" />
                <span className="text-[#00214E] font-bold text-sm leading-tight" data-id="element-279">
                  mercado
                  <br data-id="element-280" />
                  pago
                </span>
              </div>
            </div>
          </div>

          <div className="flex flex-wrap items-center justify-center gap-3 mt-8" data-id="element-281">
            <div className="flex items-center gap-2 px-3 py-1.5 rounded-full bg-navy-800 border border-gold/30 text-sm text-white/80" data-id="element-282">
              <Zap className="w-4 h-4 text-gold" data-id="element-283" />
              <span data-id="element-284">Descarga inmediata</span>
            </div>
            <div className="flex items-center gap-2 px-3 py-1.5 rounded-full bg-navy-800 border border-gold/30 text-sm text-white/80" data-id="element-285">
              <FileCheck className="w-4 h-4 text-gold" data-id="element-286" />
              <span data-id="element-287">Archivo digital de alta resolución</span>
            </div>
            <div className="flex items-center gap-2 px-3 py-1.5 rounded-full bg-navy-800 border border-gold/30 text-sm text-white/80" data-id="element-288">
              <Infinity className="w-4 h-4 text-gold" data-id="element-289" />
              <span data-id="element-290">Acceso de por vida</span>
            </div>
            <div className="flex items-center gap-2 px-3 py-1.5 rounded-full bg-navy-800 border border-gold/30 text-sm text-white/80" data-id="element-291">
              <ShieldCheck className="w-4 h-4 text-gold" data-id="element-292" />
              <span data-id="element-293">Único pago, sin mensualidades</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}